import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import { useSidebar } from '../context/SidebarContext';
// import { useChat } from '../context/ChatContext';
// import { ChatPanel } from './Chat';

const AppWithSidebar = ({ children }) => {
  const location = useLocation();
  const [isMobileView, setIsMobileView] = useState(() => {
    return typeof window !== 'undefined' && window.innerWidth < 768;
  });
  const { sidebarWidth } = useSidebar();
  // const { isPinned, panelWidth } = useChat();

  useEffect(() => {
    const checkMobileView = () => {
      const newIsMobileView = window.innerWidth < 768;
      setIsMobileView(newIsMobileView);
    };

    let resizeTimer;
    const debouncedCheck = () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(checkMobileView, 100);
    };

    checkMobileView();
    window.addEventListener('resize', debouncedCheck);
    window.addEventListener('orientationchange', debouncedCheck);

    return () => {
      clearTimeout(resizeTimer);
      window.removeEventListener('resize', debouncedCheck);
      window.removeEventListener('orientationchange', debouncedCheck);
    };
  }, []);

  // 로그인/회원가입 페이지에서는 사이드바 숨김
  const shouldShowSidebar = !isMobileView && 
    location.pathname !== '/signin' && 
    location.pathname !== '/signup';

  // 컨테이너 스타일 - 데스크톱에서 사이드바 영역만큼 왼쪽 패딩 (헤더 제외)
  const containerStyle = {
    paddingLeft: shouldShowSidebar ? `${sidebarWidth}px` : '0',
    transition: 'padding-left 300ms ease-in-out',
    minHeight: '100vh',
    position: 'relative',
  };

  return (
    <div className={isMobileView ? undefined : 'flex h-screen flex-col'} style={isMobileView ? containerStyle : undefined}>
      {!isMobileView && <Header />}
      {/* 페이지는 화면 폭과 무관하게 같은 React 트리 위치에 둔다.
          별도 데스크톱/모바일 가지로 옮기면 Routes 아래의 모든 초안과 시험지 세션이 재마운트되어 사라진다.
          모바일의 래퍼는 박스를 만들지 않아 기존처럼 페이지 자체의 레이아웃/뷰포트를 사용한다. */}
      <div className={isMobileView ? undefined : 'flex flex-1 overflow-hidden bg-gray-100'} style={isMobileView ? { display: 'contents' } : undefined}>
        {shouldShowSidebar && <Sidebar />}
        <div
          className={isMobileView ? undefined : 'flex-1 overflow-hidden bg-gray-100'}
          style={isMobileView ? { display: 'contents' } : {
            marginRight: '0',
            transition: 'margin-right 300ms ease-in-out',
          }}
        >
          {children}
        </div>
        {/* 핀 고정된 채팅 패널 자리: 페이지 트리는 그대로 유지한다. */}
      </div>
    </div>
  );
};

export default React.memo(AppWithSidebar);